export default __webpack_public_path__ + "de6935c2a897c9bf9d0da5629da6b101.png";